import React from "react";
import styles from "../../styles/Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      
      <p>Made by: Yusbely Parra @2022</p>
      
    </div>
  );
};

export default Footer;